import { NavItem } from '../Header.types';
import { navItems } from '../Header.utils';

export const mobileNavItems: NavItem[] = [
  {
    label: 'Apply for a grant',
    href: '/apply',
  },
  ...navItems,
];
